import studyResultsColumns from '@/business-logic/constants/studyResultsColumns'

export default ({ study_data }) => {
  return Object.assign({}, ...studyResultsColumns.map((col) => {
    return { [col] : study_data[col] }
  }))
}